import moment from 'moment';
import 'moment/locale/ru';
import LocaleManager from './locale-manager';

moment.locale(LocaleManager.get());

export default moment;
